import breakpointsConfig, {
  breakpointsTheme as coreBreakpointsTheme,
} from "@shared/theme/props/breakpoints";

// Export numeric breakpoints from core (for arithmetic/comparisons)
export const breakpoints = breakpointsConfig;

// Export string breakpoints for Chakra v3 theme config
export const breakpointsTheme = coreBreakpointsTheme;

// ID values that are accessed by document.getElementById() in multiple files
export const domElementIds = {
  navbarId: "navbar",
  navbarBannerId: "all-navbar-banners",
  seatingBannerId: "seating-banner",
  headerDetailsId: "header-details",
  headerTabsId: "header-tabs",
} as const;
